<script setup>
import CodeBlock from '@/assets/js/src/modules/webmasters/_components/CodeBlock.vue'
import { useTranslation, } from '@/assets/js/src/util/composables'

defineProps({
    code: {
        type: String,
        default: '',
    },
    languages: {
        type: String,
        default: '',
    },
})

const { t, } = useTranslation()
</script>

<template>
    <div>
        <h2 class="mt-5 mb-2">
            {{ t('async.webmasters.client_links.heading') }}
        </h2>
        <div v-html="t('async.webmasters.client_links.text')"></div>
        <code-block
            language="xml"
            :code="code"
        ></code-block>
        <p>
            {{ t('async.webmasters.client_links.result_heading') }}
        </p>
        <div
            class="mb-3"
            v-html="t('async.webmasters.client_links.result')"
        ></div>
        <div v-html="t('async.webmasters.client_links.params',{'languages': languages})"></div>
    </div>
</template>
